import styled from 'styled-components';

export const LoginStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LoginHeaderStyled = styled.div`
  display: flex;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
`;

export const LoginContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
